module.exports = __webpack_public_path__ + "img/shuichang.6aa4d7f9.png";